import { Link } from 'react-router-dom';

import ViewCustomer from 'profile/account/ViewCustomer';

const Profile = (props) => {
  const { customer } = props;
  return (
    <div className="c7-account-tile">
      <h3>Your Profile</h3>
      <div className="c7-account-tile__section">
        <ViewCustomer customer={customer} />
        <Link to="/profile/account/edit" className="c7-button-alt-small">
          Edit account
        </Link>
      </div>
      <div className="c7-account-tile__section">
        Password: ********
        <br />
        <Link to="/profile/account/password" className="c7-button-alt-small">
          Edit password
        </Link>
      </div>
    </div>
  );
};

export default Profile;
